<app-banner></app-banner>
<app-curated></app-curated>
<!-- <app-featured></app-featured> -->
<app-help></app-help>
<app-presentation></app-presentation>
<app-decor></app-decor>
<app-mission></app-mission>
<app-difference></app-difference>
